import { LoadingOptions } from "@ionic/angular";


export const loadingProps: LoadingOptions = {
    spinner: "circles",
    message: "Please wait...",
    translucent: true,
    cssClass: "custom-class custom-loading"
};
export const mapLoadingProps: LoadingOptions = {
    spinner: "circles",
    message: "Please wait while we load the map...",
    translucent: true,
    cssClass: "custom-class custom-loading"
};
export const disconnectedLoadingProps: LoadingOptions = {
    spinner: "lines",
    message: "Please wait...",
    translucent: true,
    cssClass: "custom-class custom-loading"
};

export const networkProblemLoadingProps: LoadingOptions = {
    spinner: "lines",
    message: "Network connection lost. App will reconnect when network is reestablished...",
    translucent: true,
    cssClass: "custom-class custom-loading"
};

export const searchingDriverLoadingProps: LoadingOptions = {
    spinner: "crescent",
    message: "Searching drivers for this trip...",
    translucent: true,
    cssClass: "custom-class custom-loading"
};
export const driverStartRaceLoadingProps: LoadingOptions = {
    spinner: "crescent",
    message: "Starting trip, please wait...",
    translucent: true,
    cssClass: "custom-class custom-loading"
};

export const tripRequestLoadingProps: LoadingOptions = {
    spinner: "circles",
    message: "Retrieving trip request information...",
    translucent: true,
    cssClass: "custom-class custom-loading"
};

export const formatAMPM = (date) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
};
